var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'wells')?_c('PaginationWells',{staticClass:"pagination-row--top"}):_vm._e(),_vm._t("default"),(_vm.type === 'wells')?_c('PaginationWells',{staticClass:"pagination-row--bottom"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }